// extracted by mini-css-extract-plugin
export default {"container":"customers-module--container--6b5de","items":"customers-module--items--90934"};